import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const auth = async (companyCode, username, password, otp) => {
  const url = CONTRACT_MANAGER_URL.AUTH
  const requestData = {
    companyCode: companyCode,
    username: username,
    password: password,
    otp: otp
  }

  try {
    const headers = {}
    const attachAccessToken = false
    const result = await bService.post(url, requestData, headers, attachAccessToken)

    return result
  } catch (err) {
    throw err
  }
}

/**
 * @param {string} username
 * @returns {Promise<object>}
 */
const checkRequireOtp = async (username) => {
  const url = `${CONTRACT_MANAGER_URL.CHECK_OTP}/${username}`

  try {
    const headers = {}
    const attachAccessToken = false
    const result = await bService.get(url, headers, attachAccessToken)

    return result
  } catch (err) {
    throw err
  }
}

export default {
  auth,
  checkRequireOtp
}
